// frontend/src/contexts/FacilityContext.js
import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { getFacilityInfo } from '../services/facilityService';

const FacilityContext = createContext({
    facilityData: null,
    facilityLoading: false,
    facilityError: null,
    refreshFacility: async () => { }
});

export const FacilityProvider = ({ children }) => {
    const [facilityData, setFacilityData] = useState(null);
    const [facilityLoading, setFacilityLoading] = useState(false);
    const [facilityError, setFacilityError] = useState(null);
    const hasFetchedRef = useRef(false);

    const fetchFacility = useCallback(async () => {
        if (hasFetchedRef.current) {
            return;
        }

        hasFetchedRef.current = true;
        setFacilityLoading(true);
        setFacilityError(null);
        try {
            const data = await getFacilityInfo();
            setFacilityData(data);
            return data;
        } catch (err) {
            const message = err.response?.data?.message || 'Failed to load facility information. Please try again later.';
            setFacilityError(message);
            return null;
        } finally {
            setFacilityLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchFacility();
    }, [fetchFacility]);

    const value = {
        facilityData,
        facilityLoading,
        facilityError,
        refreshFacility: fetchFacility
    };

    return (
        <FacilityContext.Provider value={value}>
            {children}
        </FacilityContext.Provider>
    );
};

export const useFacility = () => useContext(FacilityContext);

